import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDmTfy3ePtPB-LUZjMkaXQdOU2CmSGT5cU",
  authDomain: "lectuclubapp.firebaseapp.com",
  projectId: "lectuclubapp",
  storageBucket: "lectuclubapp.firebasestorage.app",
  messagingSenderId: "753360054120",
  appId: "1:753360054120:web:de024740ef8497a0b258dd",
  measurementId: "G-0Y9KQVG1KF"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('profile');
googleProvider.addScope('email');
googleProvider.setCustomParameters({ prompt: 'select_account' });
export { googleProvider };